import React from 'react';
import { AuthConsumer } from 'components/Auth/authContext';
import { Redirect } from 'react-router-dom';

export default (Component: any) => {
	return (props: any) => (
		<AuthConsumer>
			{({ authenticated, authorized, initiateLogin, user }) => {
				return authenticated ? (
					authorized ? (
						<Component {...props} />
					) : (
						<Redirect to={'/auth/permission-expired'} />
					)
				) : (
					initiateLogin(user)
				);
			}}
		</AuthConsumer>
	);
};
